const getDaySuffix = (day: number): string => {
  if (day >= 11 && day <= 13) return `${day}th`;
  const lastDigit = day % 10;
  if (lastDigit === 1) return `${day}st`;
  if (lastDigit === 2) return `${day}nd`;
  if (lastDigit === 3) return `${day}rd`;
  return `${day}th`;
};

export const formatDateRange = (
  startISOString: string,
  endISOString: string
): string => {
  const startDate = new Date(startISOString);
  const endDate = new Date(endISOString);

  const startDay = startDate.getUTCDate();
  const startMonth = startDate.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });
  const startYear = startDate.getUTCFullYear();

  const endDay = endDate.getUTCDate();
  const endMonth = endDate.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });
  const endYear = endDate.getUTCFullYear();

  const startDayWithSuffix = getDaySuffix(startDay);
  const endDayWithSuffix = getDaySuffix(endDay);

  if (startYear === endYear) {
    if (startMonth === endMonth) {
      return `${startDayWithSuffix}-${endDayWithSuffix} ${startMonth} ${startYear}`;
    } else {
      return `${startDayWithSuffix} ${startMonth} - ${endDayWithSuffix} ${endMonth} ${startYear}`;
    }
  } else {
    return `${startDayWithSuffix} ${startMonth} ${startYear} - ${endDayWithSuffix} ${endMonth} ${endYear}`;
  }
};

export const formatTimeCommaDate = (dateTime: string | Date | null): string => {
  if (!dateTime) return "--";
  const _dateTime = new Date(dateTime);

  const time = _dateTime.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const date = _dateTime.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return `${time}, ${date}`;
};

export const formatUSCurrency = (formatNum: number | undefined) => {
  const num = formatNum ?? 0;
  const usCurrency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return usCurrency.format(num);
};

export function formatDateWithSuffix(dateString: string) {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-US", {
    month: "long",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();

  const suffixes = ["th", "st", "nd", "rd"];
  const suffix =
    day % 10 > 3 || [11, 12, 13].includes(day)
      ? "th"
      : suffixes[day % 10] || "th";

  return `${month} ${day}${suffix} ${year}`;
}
